import React, { Component } from 'react';


import SnackBarComponent from './../components/SnackBarComponent';


//Actualizacion develop
class SnackBarDB extends Component {

    render() {
        return (
            <SnackBarComponent
                open={this.props.open}
                onClose={this.props.onClose}
                message={this.props.message}
                type={this.props.type}
            />
        );
    }
}

export default SnackBarDB;